var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.shouldShowWidgets)?_c('div',{staticClass:"extra-widget-wrapper"},[_c('span',{staticClass:"player-control-item widget-cog"},[_c('fa-icon',{attrs:{"icon":['fas', 'cog']}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }